/**
 * Usually, when an experiment is run, only two options are available - control and variant.
 * However, in rare cases, more test variants may exist for some experiments. In such situations,
 * it is mandatory to set the variable "version" in Optimizely for each non-control variant of the experiment
 * in order to send to analytics the exact version that was displayed to the user.
 */
export const getFeatureVariant = (isEnabled, version) => {
    const enableVariantVersions = isEnabled && version !== undefined && version !== '';
    const variantVersion = enableVariantVersions ? version : 'Variant';
    return isEnabled ? variantVersion : 'Control - no changes';
};
